import { gql } from '@apollo/client';
import { AssetCategoryFragment } from 'graphql/AssetCategory/fragments/AssetCategoryFragment';
import { AssetTypeFragment } from 'graphql/AssetType/fragments/AssetTypeFragment';
/**
 * @fragment AssetFragment
 * @since 1.0.0
 */
export const AssetFragment = gql `
  fragment AssetFragment on Asset {
    id
    tag
    link
    title
    infos
    active

    type {
      ...AssetTypeFragment
    }

    category {
      ...AssetCategoryFragment
    }
  }

  ${AssetTypeFragment}
  ${AssetCategoryFragment}
`;
